import { cn } from "@core-ui/utils/cn";
import { GlassPanel, GlassPanelFrame } from "@ui-kit/GlassPanel";
import { ComponentVariantProvider } from "@ui-kit/Providers";
import { forwardRef, type HTMLAttributes } from "react";

interface CommentContentProps extends HTMLAttributes<HTMLDivElement> {
	header?: React.ReactNode;
}

export const CommentContent = forwardRef<HTMLDivElement, CommentContentProps>(
	({ className, header, children, ...otherProps }, ref) => {
		return (
			<ComponentVariantProvider variant="glass">
				<GlassPanel
					className={cn(
						"group/thread comment-block max-h-[min(100vh,36rem)] w-[min(calc(100vw-16px),23.75rem)] outline-none",
						className,
					)}
					ref={ref}
					{...otherProps}
				>
					<GlassPanelFrame header={header}>{children}</GlassPanelFrame>
				</GlassPanel>
			</ComponentVariantProvider>
		);
	},
);
